module.exports = __webpack_public_path__ + "img/menuIcon.46f7ffdc.png";